<template>
    <div
        v-if="isOpen"
        class="order-summary"
        @click="closeModal()">
        <div class="order-summary__container" @click.stop>
            <button class="order-summary__upper-close-btn" @click="closeModal()"><img src="@/assets/images/decoration/cross-shop.svg"></button>
            <div class="order-summary__content">
                <subscription-dropdown v-if="hasMultipleActiveSubscriptions" class="shop__multiselect pb-3" :showLabels="false" :label="$t('ORDER_SUMMARY_DROPDOWN_LABEL')" placeholderText="Address"/>
                <h2 v-if="hasOrderThisWeek || hasNoOrders" v-text="$t('SHOP_ORDER_SUMMARY_NEXT')" class="order-summary__heading"></h2>
                <p v-if="hasNoOrders" v-text="$t('SHOP_ORDER_SUMMARY_EMPTY')" class="order-summary__paragraph m-0 pt-2 pb-4"></p>
                <button v-if="hasNoOrders" class="order-summary__button" @click="redirectToShop" v-text="$t('VISIT_SHOP')"></button>
                <p v-if="hasOrderPastCutOff" v-text="$t('SHOP_ORDER_SUMMARY_LOCKED')" class="order-summary__paragraph m-0 pt-2 pb-4"></p>
                <delivery-summary v-if="hasOrderThisWeek" :order="orderSummary[0]" :activeSubscription="activeSubscription" :currency="currency" :isThisWeek="true"/>
                <h2 v-if="hasFutureOrders" class="order-summary__heading mt-6 mb-0" v-text="$t('SHOP_ORDER_SUMMARY_LATER')"></h2>
                <delivery-summary v-if="hasFutureOrders" :order="futureOrders[0]" :activeSubscription="activeSubscription" :currency="currency" :isThisWeek="false"/>
                <recommendations
                    class="m-4"
                    :className="'order-summary'"
                    :headerText="$t('RECOMMENDATIONS_NEXT_DELIVERY')"
                    :numItems="1"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as moment from 'moment';
import { turnScrollOn, turnScrollOff } from '@/helpers/ScrollHelpers.js';
import countriesJson from '@/resources/countries.json';
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';
import DeliverySummary from '@/components/partials/account/shop/order-summary/DeliverySummary';
import Recommendations from '../../partials/account/shop/Recommendations.vue';

export default {
    name: 'OrderSummaryModal',
    components: { SubscriptionDropdown, DeliverySummary, Recommendations },
    created() {
        this.$store.dispatch('subscription/fetchAllSubscriptions');
        this.$store.dispatch('address/fetchAllAddresses');
        this.$store.dispatch('shop/fetchOrderSummary');
        this.$store.dispatch('shop/getNextDeliveryDate', true);
    },
    watch: {
        activeSubscription() {
            this.$store.dispatch('shop/fetchOrderSummary');
            this.$store.dispatch('shop/getNextDeliveryDate');
        },
    },
    computed: {
        ...mapGetters({
            hasMultipleActiveSubscriptions: 'subscription/hasMultipleActiveSubscriptions',
            activeSubscription: 'subscription/getActiveSubscription',
            orderSummary: 'shop/getOrderSummary',
            isOpen: 'shop/getOrderSummaryModalState',
            nextAvailableDelivery: 'shop/getNextAvailableDeliveryDate',
        }),
        currency() {
            if (this.orderSummary.length) {
                const country = countriesJson.find(country => country.currency.code === this.orderSummary[0].currency);
                return country.currency.symbol;
            }
            return 'GBP';
        },
        hasNoOrders() {
            const orderSummaryEmpty = this.orderSummary.length === 0;
            return orderSummaryEmpty;
        },
        hasOrderPastCutOff() {
            return this.orderSummary[0]?.pastCutOff;
        },
        hasOrderThisWeek() {
            const hasOrderBeforeCutOff = this.orderSummary[0]?.delivery_date === this.nextAvailableDelivery;
            const hasOrderThisWeek = this.hasNoOrders ? false : hasOrderBeforeCutOff || this.hasOrderPastCutOff;
            return hasOrderThisWeek;
        },
        hasFutureOrders() {
            return this.futureOrders.length;
        },
        futureOrders() {
            const futureOrders = this.orderSummary.length > 1 ? this.orderSummary.filter((order, index) => { return index !== 0; }) : [];
            return futureOrders;
        },
    },
    methods: {
        closeModal() {
            this.$store.commit('shop/closeOrderSummary');
            turnScrollOn(document);
        },
        redirectToShop() {
            this.closeModal();
            this.$router.push({ name: 'account.shop' });
        },
    },
    destroyed() {
        turnScrollOn(document);
    },
};
</script>
